import React, { ReactNode } from 'react'
import { useCurrentHashPath } from './hooks'

const SwitchHashPaths = ({ children }: { children: ReactNode }) => {
  const currentHashPath = useCurrentHashPath()
  const childrenToRender: ReactNode[] = []
  const defaultChildren: ReactNode[] = []

  React.Children.forEach(children, (child: any) => {
    const { hashPath, isDefault } = child?.props ?? {}
    hashPath === currentHashPath && childrenToRender.push(child)
    isDefault && defaultChildren.push(child)
  })

  return <>{childrenToRender.length ? childrenToRender : defaultChildren}</>
}

export default SwitchHashPaths
